import { Filter } from '../models';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';
import { MarkantFilter } from '@markant/elements';
import { TranslocoService } from '@jsverse/transloco';

/**
 * Builds a query param for the given active filters.
 *
 * Example:
 * filterKeys = ['state', 'role']
 * activeFilter = { 'state': ['ACTIVE', 'INVITED'], 'role': ['ORGANIZATION_MEMBER']}
 *
 * Method returns 'state=ACTIVE&state=INVITED&role=ORGANIZATION_MEMBER'
 *
 * @param filterKeys
 * @param activeFilter
 */
export function buildFilterQueryParameter(filterKeys: string[], activeFilter: Record<string, string[]>): string {
  const filterQuery = [];
  for (const key of filterKeys) {
    if (!activeFilter[key] || activeFilter[key].length === 0) continue;

    for (const filter of activeFilter[key]) {
      filterQuery.push([key, filter]);
    }
  }

  return new URLSearchParams(filterQuery).toString();
}

/**
 * This function create array of markant-filter from active filter record and Filter object.
 * We are using this function to update texts on currently selected filters.
 *
 * @param activeFilters
 * @param filter
 * @param translocoService
 */
export function mapActiveToMarkantFilter(
  activeFilters: Record<string, string[]>,
  filter: Filter<MarkantSelectOption>,
  translocoService: TranslocoService
): MarkantFilter[] {
  return Object.entries(activeFilters).flatMap(([groupKey, activeOptions]) =>
    activeOptions
      .map(value => filter[groupKey].filterOptions.find(option => option.value === value) as MarkantSelectOption)
      .map(option => ({
        category: {
          value: groupKey,
          representation: translocoService.translate(filter[groupKey].translationKey ?? ''),
        },
        representation: option.representation,
        value: option.value,
      }))
  );
}
